module.exports = __webpack_public_path__ + "static/media/jackpots-lvl2.57672deb.png";